export default {
    home: "Domov",
    order: {
        submit: "Zkontrolovat objednávku"
    },
    tunnel: {
        loginVerification: "Ověření přihlášení",
        addressVerification: "Ověření adresy"
    },
    catalog: "Katalog",
    all: "Vše",
    return: {
        return: "Návrat"
    },
    errors: {
        404: "@:views.errors.404.title"
    },
    impersonation: "Objednávka jménem",
    approvals: "Schválení",
    delegate: "Delegáti",
    employees: "Moji zaměstnanci",
}